var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import PopulationService from "../../../Services/Population.service";
import SharePopulationForm from "./SharePopulationForm";
import useConfirmation from "../../Hooks/useConfirmation";
const SharePopulationModal = (_a) => {
    var { populationId } = _a, modalProps = __rest(_a, ["populationId"]);
    const [confirm, confirmModals] = useConfirmation();
    return (_jsxs(ModalFormFormat, Object.assign({}, modalProps, { modalTitle: "Share Filter", handleSubmit: (request) => confirm(_jsx(_Fragment, { children: "By confirming share, user affirms a filter has not be shared containing restricted information and affirms use in a manner that complies with institution policy and FERPA requirements. User accepts that risk and responsibility." })).then((isConfirmed) => {
            var _a, _b, _c, _d;
            if (isConfirmed) {
                PopulationService.updateSharingSettings({
                    populationId,
                    readPersonIds: (_a = request.personRead) === null || _a === void 0 ? void 0 : _a.map((person) => person.personId),
                    editPersonIds: (_b = request.personEdit) === null || _b === void 0 ? void 0 : _b.map((person) => person.personId),
                    readRoleIds: (_c = request.roleRead) === null || _c === void 0 ? void 0 : _c.map((role) => role.id),
                    editRoleIds: (_d = request.roleEdit) === null || _d === void 0 ? void 0 : _d.map((role) => role.id),
                });
            }
        }), defaultValue: () => PopulationService.getSharingSettings(populationId).then((sharedSettings) => ({
            personRead: sharedSettings.readAccessPeople,
            personEdit: sharedSettings.editAccessPeople,
            roleRead: sharedSettings.readAccessRoles,
            roleEdit: sharedSettings.editAccessRoles,
        })), saveButtonContents: "Share", children: [confirmModals, _jsx(SharePopulationForm, {})] })));
};
export default SharePopulationModal;
